import apiInstance from '../utils/axiosConfig';

const AuthService = {
    //SESSION_DURATION: 5 * 60 * 1000, // 5 minutes (TEST — remettre 2h ou plus en prod)
    SESSION_DURATION: 8 * 60 * 60 * 1000,
    SESSION_TIMESTAMP_KEY: 'session_timestamp',
    USER_KEY: 'user',

    recordActivity: () => {
        localStorage.setItem(AuthService.SESSION_TIMESTAMP_KEY, Date.now().toString());
    },

    isSessionValid: () => {
        const timestampStr = localStorage.getItem(AuthService.SESSION_TIMESTAMP_KEY);
        if (!timestampStr) return false;

        const lastActivity = parseInt(timestampStr, 10);
        return (Date.now() - lastActivity) < AuthService.SESSION_DURATION;
    },

    login: async (username, password) => {
        try {
            const response = await apiInstance.post('/api/auth/login', { username, password });
            if (response.data.token) {
                localStorage.setItem(AuthService.USER_KEY, JSON.stringify(response.data));
                AuthService.recordActivity();
            }
            return response.data;
        } catch (error) {
            console.error('Error logging in:', error.message || error);
            throw error;
        }
    },

    logout: () => {
        localStorage.removeItem(AuthService.USER_KEY);
        localStorage.removeItem(AuthService.SESSION_TIMESTAMP_KEY);
    },

    getCurrentUser: () => {
        try {
            const userData = localStorage.getItem(AuthService.USER_KEY);
            if (!userData) return null;

            // Vérifie si la session a expiré (même après fermeture du navigateur)
            if (!AuthService.isSessionValid()) {
                AuthService.logout();
                return null;
            }

            const parsedData = JSON.parse(userData);

            if (parsedData.user && parsedData.token) {
                return parsedData.user;
            }
            if (parsedData.id) {
                return parsedData;
            }
            return null;
        } catch (error) {
            console.error('Error retrieving current user', error);
            return null;
        }
    },

    getToken: () => {
        try {
            const userData = localStorage.getItem(AuthService.USER_KEY);
            if (!userData) return null;

            const parsedData = JSON.parse(userData);
            return parsedData.token || null;
        } catch (error) {
            console.error('Error retrieving token', error);
            return null;
        }
    },

    isAuthenticated: () => {
        const user = AuthService.getCurrentUser();
        const token = AuthService.getToken();
        return !!(user && user.id && token);
    }
};

export default AuthService;